import React from "react";
import { Link } from "react-router-dom";

class ShoppingCartQtyForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      product: null,
      pid: null,
      qty: 1,
      productChosen: false,
      shoppingCart: null,
    };

    this.saveCartItem = this.saveCartItem.bind(this);
  }

  componentDidMount() {
    let product = null;
    let pid = null;
    let urlState = this.props.location.state;

    if (urlState) {
      product = urlState.product;
      pid = urlState.product.item.id;
    } else {
      //fetch from server using urlParams
    }

    if (product) {
      let shoppingCart = this.props.shoppingCart;
      let productChosen = false;
      let qty = 1;

      if (shoppingCart) {
        shoppingCart.forEach((item) => {
          let shopProducts = item.products;
          shopProducts.forEach((productOnCart) => {
            console.log(productOnCart);
            if (productOnCart.product.item.id === product.item.id) {
              console.log("product chosen");
              productChosen = true;
              qty = productOnCart.qty;
            }
          });
        });
      } else {
        shoppingCart = [];
      }

      this.setState({
        pid: pid,
        product: product,
        productChosen: productChosen,
        qty: qty,
        shoppingCart: shoppingCart,
      });
    }
  }

  saveCartItem(event) {
    event.preventDefault();

    let { shoppingCart, product, qty } = this.state;

    function addNewShop() {
      shoppingCart.push({
        shopName: product.shop.name,
        shopId: product.shop.id,
        address: product.shop.address,
        currency: product.shop.currency,
        products: [
          {
            product: product,
            qty: qty,
          },
        ],
      });
    }

    let foundMatchingShop = false;
    let foundMatchingProduct = false;

    if (shoppingCart.length > 0) {
      shoppingCart.forEach((item) => {
        if (item.shopId === product.shop.id) {
          item.products.forEach((prd) => {
            if (prd.product.item.id === product.item.id) {
              prd.qty = qty;
              foundMatchingProduct = true;
            }
          });

          if (!foundMatchingProduct) {
            item.products.push({
              product: product,
              qty: qty,
            });
          }

          foundMatchingShop = true;
        }
      });
    }

    if (!foundMatchingShop) {
      addNewShop();
    }

    this.props.updateShoppingCart(shoppingCart);

    if (this.props.shop) {
      this.props.history.push(
        `/shop-at/${this.props.shop.name.replace(/\s+/g, "-")}/${
          this.props.shop.id
        }/`
      );
    } else {
      this.props.history.push("/market/");
    }
  }

  render() {
    console.log(this.props);

    return (
      <div id="cart-qty-form" className="message is-info animated slideInUp">
        <div className="message-body">
          <div className="d-flex justify-content-between">
            <div>
              {this.state.product ? (
                <div>
                  {this.state.productChosen ? (
                    <span>
                      <span className="has-text-danger">
                        <small>Already Chosen! Change Qty?</small>{" "}
                      </span>
                      <p> {this.state.product.item.name}</p>
                    </span>
                  ) : (
                    <span>{this.state.product.item.name}</span>
                  )}
                  <small>
                    <p className="has-text-success">
                      ({this.state.product.shop.name})
                    </p>
                  </small>
                </div>
              ) : (
                <span></span>
              )}
            </div>
            <div>
              <Link
                to={
                  this.props.shop
                    ? `/shop-at/${this.props.shop.name.replace(/\s+/g, "-")}/${
                        this.props.shop.id
                      }/`
                    : "/market/"
                }
              >
                <button
                  type="button"
                  className="delete"
                  aria-label="close"
                ></button>
              </Link>
            </div>
          </div>

          <form action="#" onSubmit={this.saveCartItem}>
            <div className="field is-horizontal is-mobile">
              <div className="columns is-mobile">
                <div className="column is-9">
                  <input
                    onChange={(event) => {
                      this.setState({ qty: event.target.value });
                    }}
                    value={this.state.qty}
                    placeholder="Enter Quantity"
                    className="input"
                    type="number"
                  />
                </div>
                <div className="column is-3">
                  <button className="button is-info">Save</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ShoppingCartQtyForm;
